const deps = [require('./all').name, require('./addon').name, require('ui/web/addonSelect').name];

module.exports = angular
  .module('bench.app.dms.addons', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.addons', {
      abstract: true,
      url: '/addons',
      template: `\
<div class="addons">
  <bl-addon-select>
  </bl-addon-select>
  <div
    class="addons_card-wrapper"
    ui-view>
  </div>
</div>\
`,
    }),
  );
